import { ToggleChip } from '@eventbrite/marmalade';
import classnames from 'classnames';
import React, { ReactChild } from 'react';
import './ListPicker.scss';

export interface ListPickerItemProps {
    content: ReactChild;
    ariaLabel: string;
    selected?: boolean;
    payload?: any;
    disabled?: boolean;
}

export interface ListPickerProps {
    items: ListPickerItemProps[];
    itemRenderer?: (
        value: ListPickerItemProps,
        index?: number,
        array?: ListPickerItemProps[],
    ) => React.ReactElement | null;
    onItemPickedChanged?: (
        item: ListPickerItemProps,
        action: ListPickerItemActions,
    ) => void;
    classNames?: string;
    itemWrapperClassNames?: string;
    itemClassNames?: string;
}

export enum ListPickerItemActions {
    PICKED = 'PICKED',
    UNPICKED = 'UNPICKED',
}

export const ListPicker: React.FC<ListPickerProps> = ({
    items = [],
    itemRenderer = (value: ListPickerItemProps, index: Number) => (
        <ToggleChip
            key={index.toString()}
            aria-label={value.ariaLabel}
            pressed={value.selected}
            onPressedChange={(pressed) => {
                onItemPickedChanged?.(
                    value,
                    pressed
                        ? ListPickerItemActions.PICKED
                        : ListPickerItemActions.UNPICKED,
                );
            }}
            disabled={value.disabled}
            wrapperClassName={itemWrapperClassNames}
            className={itemClassNames}
        >
            {value.content}
        </ToggleChip>
    ),
    onItemPickedChanged,
    classNames,
    itemWrapperClassNames,
    itemClassNames,
}) => {
    // Only the first selected item can be selected
    const firstSelectedIndex = items.findIndex((item) => item.selected);
    const updatedItems = items.map((item, index) => {
        if (index === firstSelectedIndex) {
            return item;
        }
        return { ...item, selected: false };
    });

    return (
        <div
            className={classnames('eds-list-picker__wrapper', classNames)}
            data-testid="listPickerWrapper"
        >
            {updatedItems.map(itemRenderer)}
        </div>
    );
};
